export default __webpack_public_path__ + "static/media/ips.1dbae8b2.svg";